export default {
    props: {
        order: {
            required: false,
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            data: {},
        }
    },
    methods: {
        valueChange(key, value) {
            this.$emit('value-change', { key, value });
        },
        orderHandle(value) {},
    },
    watch: {
        order: {
            handler(value) {
                this.orderHandle(value);
            },
            immediate: true,
        },
        data: {
            handler(value) {
                this.valueChange(this.key, value);
            },
            deep: true,
            immediate: true,
        }
    }
}
